import { ListSubheader, type ListSubheaderProps } from '@mui/material'

export type MolsonListSubheaderProps = ListSubheaderProps & {
  dataTestId?: string
}

export const MolsonListSubheader = ({
  dataTestId,
  children,
  ...props
}: MolsonListSubheaderProps) => {
  return (
    <ListSubheader data-testid={dataTestId} {...props}>
      {children}
    </ListSubheader>
  )
}
